import { createFileRoute } from "@tanstack/react-router"

import QuizBuilder from "@/components/Quizzes/QuizBuilder"

export const Route = createFileRoute("/_layout/quiz-management/$quizId/edit")({
  component: EditQuizRoute,
})

function EditQuizRoute() {
  const { quizId } = Route.useParams()
  return <QuizBuilder mode="edit" quizId={quizId} />
}
